module.exports = __webpack_public_path__ + "img/finance-icon-1.1d5cbed1.svg";